import { render, staticRenderFns } from "./DynamicDataProgramBuilder.vue?vue&type=template&id=81d39ef0&scoped=true"
import script from "./DynamicDataProgramBuilder.vue?vue&type=script&lang=js"
export * from "./DynamicDataProgramBuilder.vue?vue&type=script&lang=js"
import style0 from "./DynamicDataProgramBuilder.vue?vue&type=style&index=0&id=81d39ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d39ef0",
  null
  
)

export default component.exports